import styled from 'styled-components'

const ContainerStyle = styled.section.attrs({})`
padding: 0 var(--containerPadding);
width: 100%;

    &.relative {
        position: relative;
    }
`
export default ContainerStyle
